import { createApp } from 'vue'
import './style.sass'
import App from './App.vue'

createApp(App).mount('#app')
